// extracted by mini-css-extract-plugin
export var label = "_hd-2";
export var slideContainer = "_hd-0";
export var slider = "_hd-1";